import type React from 'react';

import State, { StateType } from './State';
import { statePaths } from './stateInfo';

interface InactiveStatesGroupProps {
  states: string[];
}

const InactiveStatesGroup: React.FC<InactiveStatesGroupProps> = ({
  states,
}) => {
  return (
    <>
      {states.map((state) => (
        <State
          key={state}
          state={state}
          type={StateType.INACTIVE}
          path={statePaths[state]}
        />
      ))}
    </>
  );
};

export default InactiveStatesGroup;
